/**
 * A release que ESTE aparelho está rodando, legível sem DevTools (rodada 2C).
 *
 * Existe para o teste físico: cada linha da matriz de aparelhos registra a
 * release testada, e a pessoa que testa precisa conseguir ler (ou tirar um
 * print) sem ferramenta técnica. Mostra três coisas, e só três:
 *
 *   - `app`: o commit embutido no bundle em execução (`CLIENT_RELEASE`) —
 *     é ele que distingue "bundle antigo servido pelo Service Worker";
 *   - `servidor`: o último `x-server-release` visto pelo fetch instrumentado
 *     (nenhuma chamada nova: se ainda não houve resposta da API, fica "—");
 *   - `instalado`/`navegador`: o modo de exibição, porque push no iOS e o
 *     ciclo de atualização dependem disso.
 *
 * Não é tela "Sobre", não tem botão, não faz requisição. Nada de identidade
 * da conta aqui — é só a identidade do build.
 */
import { reporter } from './instalar';
import { CLIENT_RELEASE, estaStandalone, releaseCurta } from './release';

export function ReleaseDoApp() {
  const servidor = reporter().serverRelease();
  return (
    <p className="auth-note" data-testid="release-do-app">
      Versão do app: <code data-testid="release-cliente">{releaseCurta(CLIENT_RELEASE)}</code> · servidor:{' '}
      <code data-testid="release-servidor">{servidor ? releaseCurta(servidor) : '—'}</code> ·{' '}
      <span data-testid="modo-de-exibicao">{estaStandalone() ? 'instalado' : 'navegador'}</span>
    </p>
  );
}
